<template>
    <div>
        <header class="form-title">
            <Row>
                <Col span="22">
                    <Form  inline  :label-width="80" >
                        <FormItem prop="user" label="供应商">
                            <el-Select size="small" filterable v-model="formSelect.user" class="formSelect-input">
                                <el-Option
                                :value="k.id"
                                v-for="(k,v) in customerList"
                                :key="v"
                                :label="k.name+(k.phone!=null?k.phone:'')"
                                >{{k.name+(k.phone!=null?k.phone:"")}}</el-Option>
                            </el-Select>
                        </FormItem>
                        <FormItem prop="password" label="门店">
                            <Input v-model="formSelect.store"  class="formSelect-input"  disabled  />
                        </FormItem>
                        <FormItem prop="password" label="采购员">
                            <Input v-model="adminuser"  class="formSelect-input"  disabled  />
                        </FormItem>
                    </Form>
                </Col>
                <Col span="2" align="right"><Button type="primary" style="position: relative;top: -10px;" @click="commodityModal=true"><Icon type="md-add" /></Button></Col>
            </Row>
        </header>
        <div>
            <Alert v-if="afterSelection.length==0" align="center">请添加数据</Alert>
            <Collapse v-model="opensTable"  v-if="afterSelection.length!=0">
                <Panel :name="index+''"  v-for="(item,index) in afterSelection" :key="index">
                    <span>{{ item.goodsname }} ({{item.goodscode}})</span>
                    <table slot="content" class="ive-table">
                        <thead>
                        <th>商品图</th>
                        <th>出入</th>
                        <th>规格</th>
                        <th>颜色</th>
                        <th>采购价<span class="finger" @click="editallprice(item)"><Icon type="md-create" /></span> </th>
                        <th>数量</th>
                        <th>小计</th>
                        <th>操作</th>
                        </thead>
                        <tbody>
                        <tr align="center" v-for="(k,v) in item.goodsItem">
                            <td :rowspan="item.goodsItem.length" v-if="v==0" width="240">
                                <Fy-Img
                                        :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                                        :Width="100"
                                        :Height="100"
                                ></Fy-Img>
                            </td>
                            <td>
                                <span v-if="k.nums>0" style="color: #4aca58">换入</span>
                                <span v-if="k.nums<0" style="color: red">换出</span>
                            </td>
                            <td>{{k.size}}</td>
                            <td>{{k.color}}</td>

                            <td class="finger">
                                <InputNumber style="width: 100px" v-model="k.cprice" size="small" :min="0" :max="999999" :precision="2"  @on-change="editprice(item,v,k.cprice,1)"></InputNumber>
                            </td>

                            <td class="finger">
                                <InputNumber v-if="isShowcprice" v-model="k.nums" size="small" :max="9999" :min="Math.abs(k.num)*-1" @on-change="editprice(item,v,k.nums,2)"></InputNumber>
                                <InputNumber v-else v-model="k.nums" size="small" :max="9999" @on-change="editprice(item,v,k.nums,2)"></InputNumber>
                            </td>

                            <td>{{(k.cprice*k.nums).toFixed(2)}}</td>
                            <td  :rowspan="item.goodsItem.length" v-if="v==0" width="200">
                                <ButtonGroup shape="circle">
                                    <Button type="primary" icon="md-create" title="编辑" @click="editSendData(item)"></Button>
                                    <Button type="warning" icon="md-trash" title="删除" @click="delSendData(item,index)"></Button>
                                </ButtonGroup>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </Panel>
            </Collapse >
            <Row v-if="afterSelection.length!=0" style="margin-top: 30px">
                <Col span="4"><span class="msg">商品金额：<strong>{{formSelect.showMoneys.toFixed(2)}}</strong></span></Col>
                <Col span="4"><span class="msg">商品数量：<strong>{{formSelect.total}}</strong></span></Col>
                <Col span="4"><span class="msg">欠供应商款：<strong>{{formSelect.customerArrears.toFixed(2)}}</strong></span></Col>
                <Col span="4"><span class="msg">本单欠款：<strong>{{formSelect.nomoneys}} </strong></span></Col>
                <Col span="20">
                    <Form  inline  :label-width="80" >
                        <FormItem label="结算账户">
                            <Select v-model="formSelect.bank"  class="formSelect-input">
                                <Option
                                        v-if="k.type!=6"
                                        :value="k.id"
                                        v-for="(k,v) in bankList"
                                        :key="v">{{k.bankname}}</Option>
                            </Select>
                        </FormItem>
                        <FormItem  label="实收金额">
                            <InputNumber v-model="formSelect.realMoney" :precision="2" :max="999999" :min="0" class="formSelect-input" ></InputNumber>
                        </FormItem>
                    </Form>
                </Col>
                <Col span="4" align="center" >
                    <span>合计：{{Lastmoney.toFixed(2)}}</span>
                    <Button type="primary" :loading="loadingOpeningOrder" @click="openingOrder()" style="margin-left: 15px">
                        <span v-if="!loadingOpeningOrder">采购</span>
                        <span v-else>提交中</span>
                    </Button>
                </Col>
                <Col span="6">
                    <Form  inline  :label-width="60" >
                        <FormItem label="备注">
                            <Input v-model="formSelect.remark" type="textarea" style="width: 500px" :maxlength="50" placeholder="备注(最多50个字符)" />
                        </FormItem>
                    </Form>
                </Col>
            </Row>
        </div>
        <!--选择商品-->
        <Modal
                width="90%"
                v-model="commodityModal"
                title="选择添加的商品">
            <Form  inline>
                <FormItem prop="password">
                    <Input type="text"  v-model="searchNeirong" placeholder="请输入商品名、货号">
                    </Input>
                </FormItem>
                <FormItem>
                    <Button type="primary" @click="getGoodsList()">确定</Button>
                </FormItem>
            </Form>
            <div class="demo-split">
                <Split v-model="split">
                    <div slot="left" class="demo-split-pane">
                        <table slot="content" class="ive-table">
                            <thead>
                            <th>选择</th>
                            <th width="100">商品图</th>
                            <th width="180">名称</th>
                            <th>货号</th>
                            <th>库存</th>
                            <th>零售价</th>
                            <th v-if="ispfprice">批发价</th>
                            <th v-if="cpriceFlag">采购价</th>
                            <th>已选</th>
                            </thead>
                            <tbody>
                            <tr align="center" v-for="(item, index) in goodsListL" :key="index"  @click="setDataListFn(goodsListL,index)" style="cursor: pointer">
                                <td width="80">
                                    <RadioGroup v-model="resultItem.single">
                                        <Radio :label="item.id">{{index+1}}</Radio>
                                    </RadioGroup>
                                </td>
                                <td>
                                    <div class="imgbox">
                                        <Fy-Img
                                                class="img"
                                                :ImgSrc="item.goodsimg | filtImg(item.goodsimg)"
                                                :Width="50"
                                                :Height="50">
                                        </Fy-Img>
                                        <span v-if="item.tagCode!=null">总</span>
                                    </div>
                                <td>{{item.name}}</td>
                                <td >{{item.goodscode}}</td>
                                <td>{{item.num}}</td>
                                <td >{{item.lprice}}</td>
                                <td  v-if="ispfprice">{{item.pprice}}</td>
                                <td v-if="cpriceFlag">{{item.cprice}}</td>
                                <td v-if="item.nums>0" style="color: #ff9900">{{item.nums}}</td>
                                <td  v-else>{{item.nums}}</td>
                            </tr>
                            </tbody>
                        </table>
                        <div class="pageTotal">
                            <Page  :total="page.total"
                                   show-total
                                   :current.sync="page.current"
                                   :page-size="page.rows"
                                   @on-change="onChange" />
                        </div>
                    </div>
                    <div slot="right" class="demo-split-pane">
                        <div class="commodityMsg">
                            <span  class="img" v-if="resultItem.goodsimg==''">暂无商品图片</span>
                            <Fy-Img
                                    class="img"
                                    :ImgSrc="resultItem.goodsimg"
                                    :Width="80"
                                    :Height="80"
                            ></Fy-Img>
                            <h2>{{resultItem.name}} </h2>
                            <h3 v-if="cpriceFlag">采购价: <span class="money"> ￥{{resultItem.price}}</span></h3>
                            <h3>库存:<span  class="num"> {{resultItem.num}}</span></h3>
                        </div>
                        <div style="max-height: 400px;overflow: auto" class="overflowRightNav">
                            <div class="commodityClolr">
                                <h3>选择颜色</h3>
                                <span class="tag"
                                      v-for="(m,n) in resultItem.colors"
                                      :key="n" :class="{isSelectClass:selectColorGroup.isCheckable==n}"
                                      @click="setColorsFn(goodsListL,selectColorGroup.index,n)" >
                              {{m.color}}
                          </span>
                            </div>
                            <div class="commoditymiss">
                                <div style="text-align: right;padding-right: 56px; color: #999;">(正为换入，负为换出)</div>
                                <table>
                                    <tr>
                                        <th>库存</th>
                                        <th>规格</th>
                                        <th>颜色</th>
                                        <th>
                                            <!--判断是否开始 采购平均价 是否加限制-->
                                            <InputNumber v-if="isShowcprice" size="small" :readonly="numsreadonly" :min="allminnum" @on-change="selectDataAll" v-model="selectData.all"  @on-focus="allchangeNums(numsreadonly)"></InputNumber>
                                            <InputNumber v-else size="small"  @on-change="selectDataAll" v-model="selectData.all"></InputNumber>
                                        </th>
                                    </tr>
                                    <tr v-for="(item, index) in resultItem.goodsItem">
                                        <td>{{item.num}}</td>
                                        <td>{{item.size}}</td>
                                        <td>{{item.color}}</td>
                                        <td>
                                            <InputNumber  v-if="isShowcprice" size="small" :readonly="item.num<0" v-model="item.nums" :min="Math.abs(item.num)*-1" @on-change="changeNums(item)" @on-focus="changeNums(item)"></InputNumber>
                                            <InputNumber  v-else size="small"  v-model="item.nums"   @on-change="changeNums(item)"  ></InputNumber>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                        <div class="Total">
                            <h3>
                                <Row>
                                    <Col span="12">共: {{summary.totalPieces}} 件</Col>
                                    <Col span="12">合计:￥ {{summary.totalMoney.toFixed(2)}}</Col>
                                </Row>
                            </h3>
                        </div>
                    </div>
                </Split>
            </div>
            <div slot="footer">
                <Button type="text" @click="commodityModal=false">取消</Button>
                <Button type="primary" @click="addsSelectItem('true')">确定</Button>
            </div>
        </Modal>

    </div>
</template>
<script>
    import FyImg from "../../components/Common/FyImg";
    export default {
        components: {FyImg},

        data() {
            return {
                cid:'',
                sid:'',
                adminuser:JSON.parse(localStorage.getItem('adminUser')).name, //当前登录的采购员
                opensTable:'0',//默认展开第一个
                customerList:[],//供应商
                bankList:[],//结算账户
                loadingOpeningOrder:false,
                formSelect:{
                    user:'',
                    store:'',
                    adminuserid:JSON.parse(localStorage.getItem('adminUser')).id,
                    salesperson:JSON.parse(localStorage.getItem('adminUser')).id,
                    salespersonid:null,
                    bank:'',
                    bankName:'',
                    realMoney:0,
                    nomoneys:0, //本单欠款
                    customerArrears:0,
                    showMoneys:0,//商品金额，
                    total:0,//总件数
                    remark:'',
                },
                afterSelection:[],//发送的数据
                currentPageData:[],//当前页所选的数据
                searchNeirong:"",
                resultItem:{//默认显示详情
                    single:null,
                    img:'',
                    name:'',
                    price:'',
                    num:'',
                    colors:[],
                    sizes:[],
                    goodsItem:[]
                },
                resultNum:0,
                selectData:{
                    all:0,
                },
                //总件
                summary:{
                    totalPieces:0,
                    totalMoney:0,
                },

                //记录数选择数值
                selectColorGroup:{
                    isCheckable:0,
                    index:0
                },
                goodsListL:[],

                commodityModal:false,

                split: 0.7,
                page:{
                    current:1,//当前页
                    total:1,
                    page:1,
                    rows:8,
                },
                isShowcprice:false,
                numsreadonly:false, //是否限制修改数量
                allminnum:0,//添加商品可修改的最下值
                Lastmoney:0, //最后实际付款
                ispfprice:true, //判断是否显示批发价
                ischooseing:true,
                getEdtiVal:'',
                itemid:'',//修改百分比记录点击的是哪条数据
                itemi:'',//修改百分比记录点击的是哪条数据的子级
                cpriceFlag:true,//成本权限
            };
        },
        created: function() {
            //获取用户信息
            this.cid= JSON.parse(localStorage.getItem('shop')).cid
            this.sid = JSON.parse(localStorage.getItem('shop')).id
            JSON.parse(localStorage.getItem('shop')).iscprice==0?this.isShowcprice=false:this.isShowcprice=true
            this.formSelect.store = JSON.parse(localStorage.getItem('shop')).name
            this.formSelect.salesperson=JSON.parse(localStorage.getItem('adminUser')).name
            this.formSelect.salespersonid=JSON.parse(localStorage.getItem('adminUser')).id
            this.getGoodsList(this.cid,this.sid)
            this.getCustomerList();
            this.getBankList();
            //成本权限
            var PermisCode=  JSON.parse(sessionStorage.getItem('access')).code;
            if(!PermisCode.includes('94')){    
                this.cpriceFlag = false;
            }            
        },

        watch: {
            /*搜索商品*/
            'searchNeirong': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.$set(this.page,'page',1)
                    this.$set(this.page,'current',1)
                    this.getGoodsList(this.cid,this.sid)
                }
            },
            'formSelect.realMoney': {
                deep: true,
                handler: function (newVal, oldVal) {
                    this.formSelect.nomoneys = this.formSelect.showMoneys-newVal

                    this.Lastmoney =newVal
                }
            },
            'formSelect.user': {
                deep: true,
                handler: function (newVal,oldVal){
                    this.customerList.forEach((item,index)=>{
                        if( item.id == newVal ){
                            this.formSelect.customerArrears = item.money
                            this.formSelect.user = item.id
                            this.formSelect.username = item.name
                        }
                    })

                }
            },
            'formSelect.bank':{
                deep: true,
                handler: function (newVal,oldVal){
                    this.bankList.forEach((item,index)=>{
                        if( item.id == newVal ){
                            this.formSelect.bankName= item.bankname
                        }
                    })

                }
            },

            //扫码商品啊
            scanGoods:{
                  deep:true,
                    handler:function(val){
                            if( this.currentPageData==''){
                                this.currentPageData.push(val)
                            }else {
                                var flags=true
                                for (var i=0; i<this.currentPageData.length; i++) {
                                    if(this.currentPageData[i].id==val.id){
                                        this.currentPageData[i].goodsItem.forEach(item=>{
                                            item.nums++
                                        })
                                        flags=false
                                        break;
                                    } 
                                }
                                if(flags){
                                    this.currentPageData.push(val)
                                }
                            }
                            sessionStorage.setItem('gools',JSON.stringify(this.currentPageData))
                            this.addsSelectItem("true")
                    },
            }
        },
        computed:{
            scanGoods(){
                return this.$store.state.scanGoods;
            }
        },
        beforeDestroy(){
            this.$store.commit("clearScanGoods");
        },
        methods: {
            //修改价格   item每条数据 i-goodsItem第几个 price价格 flag客户类别 type类别 1代表修改价格 2修改百分比 3修改数量
            editprice(item,i,price,type){
                if(!price){price=0}
                this.getEdtiVal= price
                this.afterSelection.forEach((alt)=>{
                    if(alt.goodsid==item.goodsid){
                        if(type==1){ //修改单价
                            alt.goodsItem[i].cprice = this.getEdtiVal
                        }else { //修改数量
                            if((type==2 && this.getEdtiVal==0 )||(type==2 && !this.getEdtiVal)){
                                this.getEdtiVal=1
                            }
                            alt.goodsItem[i].nums = this.getEdtiVal
                        }
                    }
                })
                this.formSelect.showMoneys=0
                this.formSelect.total=0
                this.afterSelection.forEach( (item,index)=>{
                    item.goodsItem.forEach((m,n)=>{
                        this.formSelect.showMoneys += m.nums*m.cprice
                        this.formSelect.total+= m.nums
                    })
                })
                this.Lastmoney=this.formSelect.showMoneys
                this.formSelect.realMoney= this.formSelect.showMoneys
                this.formSelect.nomoneys = this.formSelect.showMoneys-this.formSelect.realMoney

            },

            /** 修改总的单价 **/
            editallprice(item,flag,type){
                this.getEdtiVal=0
                this.$Modal.warning({
                    render: (h) => {
                        return h('InputNumber', {
                            props: {
                                value: null,
                                autofocus: true,
                                min:0,
                                max:999999
                            },
                            on: {
                                input: (val) => {
                                    this.getEdtiVal=val
                                }
                            },
                        })
                    },
                    onOk: () => {
                        if(this.getEdtiVal!=''){
                            this.afterSelection.forEach((alt)=>{
                                if(alt.goodsid==item.goodsid){
                                    alt.goodsItem.forEach(w=>{
                                        w.cprice=this.getEdtiVal
                                    })
                                }
                            })
                            this.formSelect.showMoneys=0
                            this.formSelect.total=0
                            this.afterSelection.forEach( (item,index)=>{
                                item.goodsItem.forEach((m,n)=>{
                                    this.formSelect.showMoneys += m.nums*m.cprice
                                    this.formSelect.total+= m.nums
                                })
                            })
                            this.Lastmoney=this.formSelect.showMoneys
                            this.formSelect.realMoney= this.formSelect.showMoneys
                            this.formSelect.nomoneys = this.formSelect.showMoneys-this.formSelect.realMoney
                        }
                    },
                })
            },
            //加载缓存中的再次开单
            getSessionData(){
                var tabledata = JSON.parse(sessionStorage.getItem('openaddpurc'))

                this.afterSelection = tabledata.pgoods
                this.afterSelection.forEach((item)=>{
                    item.goodsItem.forEach(m=>{
                        this.formSelect.total+=m.quantity
                    })
                })

                this.formSelect.user = tabledata.supplierid
                this.formSelect.salesperson = tabledata.adminid
                this.formSelect.showMoneys = tabledata.money
                this.formSelect.realMoney = tabledata.money
                this.Lastmoney = tabledata.money

            },
            getCustomerList(){
                //获取供应商列表
                this.$Api.getSupplierList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000
                }).then(res => {
                    if(res.code==200){
                        this.customerList = res.data
                        this.customerList=res.data.filter(item => item.isdel==1 )
                        this.formSelect.user =  this.customerList[0].id
                        this.formSelect.username = this.customerList[0].name
                        this.formSelect.customerArrears = this.customerList[0].money

                        /**再次开单回填**/
                        if(this.$route.query.type!=undefined){
                            this.commodityModal=false
                            this.getSessionData() //再次开单
                        }
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });

            },
            //获取所有商品列表
            getGoodsList(){
                this.$Api.getListByGoodsnameOrGoodscode({
                    cid: this.cid,
                    sid: this.sid,
                    page: this.page.page,
                    rows: this.page.rows,
                    condition:this.searchNeirong,//查询内容
                }).then(res => {
                    if(res.code==200){
                        this.page.total = res.count
                        this.goodsListL = res.data
                        this.setDataListFn(this.goodsListL,0)
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            setDataListFn(getData,i){
                this.resultItem.single = getData[i].id;
                this.resultItem.goodsimg = getData[i].goodsimg;
                this.resultItem.name = getData[i].name;
                this.resultItem.price = getData[i].cprice;
                this.resultItem.num = getData[i].num;
                this.resultItem.colors =getData[i].colors;
                this.selectColorGroup.index=i


                /*** 回填缓存中的数据 **/
                var sessgools = JSON.parse(sessionStorage.getItem('gools'))
                if(sessgools!=null){
                    sessgools.forEach((item,index)=>{
                        this.goodsListL.forEach((m,n)=>{
                            if(item.id==m.id){
                                this.goodsListL[n]=sessgools[index]
                            }
                        })
                    })
                }

                this.setMoneyall()
                this.setColorsFn(getData,i,0)
            },
            //选择的颜色
            setColorsFn(getData,i,n){
                this.selectData.all=0
                this.resultNum=0
                this.selectColorGroup.isCheckable=n
                var resultColor = getData[i].colors[n].color
                var resultGoodsItem = getData[i].goodsItem
                this.resultItem.goodsItem=[]
                resultGoodsItem.forEach((k,v)=> {
                    if(resultGoodsItem[v].color==resultColor){
                        this.resultItem.goodsItem.push(k)
                    }
                })

                this.numsreadonly=false
                this.resultItem.goodsItem.forEach(w=>{
                    if(w.num<0){
                        this.numsreadonly=true
                    }
                })

                /*查找最小值*/
                this.allminnum=0
                let arrnum=[]
                if(!this.numsreadonly){
                    this.resultItem.goodsItem.forEach(w=>{
                        arrnum.push(w.num)
                    })
                }
                this.allminnum= Math.abs(Math.min(...arrnum))*-1

            },
            //修改总数量
            selectDataAll(n){
                if(n == this.resultNum+1){
                    this.resultItem.goodsItem.forEach((item,index)=>{
                        this.resultItem.goodsItem[index].nums++
                    })
                } else if(n+1 ==this.resultNum){
                    this.resultItem.goodsItem.forEach((item,index)=>{
                            this.resultItem.goodsItem[index].nums--
                    })
                }else {
                    this.resultItem.goodsItem.forEach((item,index)=>{
                        if( n > this.resultItem.goodsItem[index].nums||n < this.resultItem.goodsItem[index].nums){
                            this.resultItem.goodsItem[index].nums=n
                        }
                    })
                }
                this.resultNum = n
                this.setMoneyall()
            },
            changeNums(data){
                if(data.num<0 && this.isShowcprice ){
                    this.$Modal.confirm({
                        title: '提示',
                        content: '<p>当前库存小于0，请先盘点再进行采购</p>',
                        okText: '盘点',
                        onOk: () => {
                            this.$router.push('/addInvhist');
                        },
                    });
                    return
                }
                this.setMoneyall()
            },
            allchangeNums(str){
                if(str){
                    this.$Modal.confirm({
                        title: '提示',
                        content: '<p>当前库存小于0，请先盘点再进行采购</p>',
                        okText: '盘点',
                        onOk: () => {
                            this.$router.push('/addInvhist');
                        },
                    });
                    return
                }
            },
            setMoneyall(){
                /** 计算当前向的总件数和总金额 **/
                var allPieces=0
                var checks=0
                this.goodsListL[this.selectColorGroup.index].goodsItem.forEach((value,index)=>{

                    checks=checks+value.nums
                    allPieces=allPieces+this.goodsListL[this.selectColorGroup.index].goodsItem[index].nums
                })
                //计算酸选的总数
                this.goodsListL[this.selectColorGroup.index].nums=checks

                if(checks==0){
                    var sessgools = JSON.parse(sessionStorage.getItem('gools'))
                    var goodID = this.goodsListL[this.selectColorGroup.index]
                    if(sessgools!=null){
                        sessgools.forEach((item,index)=>{
                            if(item.id==goodID.id){
                                sessgools.splice(index,1);
                            }
                        })
                        this.currentPageData.forEach((item,index)=>{
                            if(item.id==goodID.id){
                                this.currentPageData.splice(index,1);
                            }
                        })
                        sessionStorage.setItem('gools',JSON.stringify(sessgools))
                    }
                }
                //总件数
                this.summary.totalPieces=allPieces
                //总金额
                this.summary.totalMoney=allPieces*this.resultItem.price
                this.selectDataSingle()
            },

            //设置缓存所选择的项
            selectDataSingle(){
                /** 储存当前页的所选数据 **/
                var listArray=null
                for(var i=0;i<this.goodsListL[this.selectColorGroup.index].goodsItem.length;i++) {
                    if(this.goodsListL[this.selectColorGroup.index].goodsItem[i].nums!=0){
                        listArray = this.goodsListL[this.selectColorGroup.index]
                        break
                    }
                }
                if(listArray!=null){
                    if( this.currentPageData==''){
                        this.currentPageData.push(listArray)
                    }else {
                        var flags=true
                        for (var i=0; i<this.currentPageData.length; i++) {
                            if(this.currentPageData[i].id==listArray.id){
                                this.currentPageData[i]=listArray
                                flags=false
                                break;
                            }
                        }
                        if(flags){
                            this.currentPageData.push(listArray)
                        }
                    }
                    sessionStorage.setItem('gools',JSON.stringify(this.currentPageData))
                }

            },


            //添加按钮
            addsSelectItem(str){
                var getGools = JSON.parse(sessionStorage.getItem('gools'))
                this.afterSelection=[]
                var listArray1=[]
                getGools.forEach((item,index)=>{
                    if( JSON.stringify(item) != "{}") {
                        var itemArray = [];
                        item.goodsItem.forEach((m, v) => {
                            if (m.nums != 0) {
                                var isPP = 0
                                if (m.nums > 0) {
                                    isPP = 0
                                } else {
                                    isPP = 1
                                }
                                itemArray.push({
                                    color: m.color,
                                    colorid: m.colorid,
                                    cprice: item.cprice,
                                    goodsid: m.goodsid,
                                    id: m.id,
                                    quantity: m.nums,
                                    size: m.size,
                                    sizeid: m.sizeid,
                                    nums: m.nums,
                                    sid: m.sid,
                                    isPP: isPP,
                                    num:  m.num
                                })
                            }
                        })
                        if (itemArray != '') {
                            listArray1.push({
                                goodsItem: itemArray,
                                goodscode: item.goodscode,
                                goodsid: item.id,
                                goodsimg: item.goodsimg,
                                goodsname: item.name,
                                cprice: item.cprice,
                            })
                            itemArray = []
                        }
                    }
                })
                if(this.afterSelection==''){
                    this.afterSelection=listArray1
                }else {
                    listArray1.forEach((item, index)=>{
                        if( this.afterSelection.indexOf(item)==-1){
                            this.afterSelection.splice(index,1,item)
                        }else {
                            this.afterSelection.push(item)
                        }
                    })
                }
                if(str=='true'){
                    this.commodityModal=false
                }
                this.formSelect.showMoneys=0
                this.formSelect.total=0
                this.afterSelection.forEach( (item,index)=>{
                    item.goodsItem.forEach((m,n)=>{
                        this.formSelect.showMoneys += m.nums*item.cprice
                        this.formSelect.total+= m.nums
                    })
                })
                this.Lastmoney=this.formSelect.showMoneys
                this.formSelect.realMoney= this.formSelect.showMoneys
                this.formSelect.nomoneys = this.formSelect.showMoneys-this.formSelect.realMoney

            },


            //重新编辑
            editSendData(data){
                this.commodityModal=true
                // let i=0
                // this.goodsListL.forEach((item,index)=>{
                //     if(data.id==item.id){
                //         i = index
                //     }
                // })
                // this.setDataListFn(this.goodsListL,i)
            },

            //删除
            delSendData(k,index){
                var sessgools = JSON.parse(sessionStorage.getItem('gools'))
                if(sessgools!=null){
                    sessgools.forEach((item,index)=>{
                        if(k.id==item.id){
                            sessgools.splice(index,1);
                        }
                    })
                    sessionStorage.setItem('gools',JSON.stringify(sessgools))
                }
                this.afterSelection.splice(index,1)
                this.currentPageData=this.afterSelection
                this.goodsListL.forEach((item,index)=>{
                    if(k.id==item.id){
                        item.nums=0
                        item.goodsItem.forEach((m,n)=>{
                            m.nums=0
                        })
                    }
                })
                this.formSelect.showMoneys=0
                this.formSelect.total=0
                this.afterSelection.forEach( (item,index)=>{
                    item.goodsItem.forEach((m,n)=>{
                        this.formSelect.showMoneys += m.nums*item.lprice
                        this.formSelect.total+= m.nums
                    })
                })

            },

            //修改分页
            onChange(e){
                this.page.page=e
                this.getGoodsList()//加载分页数据
                //this.addsSelectItem()

            },
            //获取银行卡
            getBankList(){
                this.$Api.getBankList({
                    cid: this.cid,
                    sid: this.sid,
                    page: 1,
                    rows: 1000,
                }).then(res => {
                    if(res.code==200){
                        this.bankList =  res.data
                        this.formSelect.bank = res.data[0].id
                    }else {
                        this.$Message.warning(res.msg);
                    }
                });
            },
            //出售开单
            openingOrder(){
                this.formSelect.total=0
                this.afterSelection.forEach((item)=>{
                    item.goodsItem.forEach((m)=>{
                        m.quantity=m.nums
                        this.formSelect.total+=m.nums
                    })
                })


                if(!this.formSelect.realMoney){
                    this.formSelect.realMoney=0
                }
                var data={
                    adminid:this.formSelect.salespersonid,
                    bank: this.formSelect.bankName,
                    bankid: this.formSelect.bank,
                    cid: this.cid,
                    sid: this.sid,
                    pgoods: this.afterSelection,
                    supplierid: this.formSelect.user,
                    suppliername:this.formSelect.username,
                    money: this.formSelect.showMoneys, //总金额
                    nomoney: this.formSelect.nomoneys,
                    paymoney: this.formSelect.realMoney,
                    remark:this.formSelect.remark,
                    status: "4",
                    total: this.formSelect.total,
                }

                this.loadingOpeningOrder=true
                this.$Api.addPurchase(data).then(res => {
                    if(res.code==200){
                        this.$Message.success('开单成功');
                        this.$router.push({
                            path:'/historyDetail',
                            query:{
                                id:res.data.purchaseId
                            }
                        })
                    }else {
                        this.$Message.warning(res.msg);
                    }
                    sessionStorage.removeItem('gools');
                    this.loadingOpeningOrder=false
                }).catch( (err)=> {
                    this.loadingOpeningOrder=false
                });
            },
        }
    };
</script>

<style lang="scss" scoped>
    .form-title{

        line-height: 54px;
        border-bottom: 1px solid #d9d9d9;
        margin-bottom: 20px;
    }
    .ive-table{
        width: 100%;
        border-collapse: collapse;
        th{
            background: #bfdeff;
            padding: 10px;
        }
        tr td{
            border: 1px solid #ececec;
            padding: 5px;
        }
    }
    .demo-split{
        height: 600px;
        border: 1px solid #dcdee2;
    }
    .demo-split-pane{
        padding: 20px ;
        position: relative;
        height: 598px;
    }
    .commodityMsg{
        position: relative;
        padding-left: 105px;
        margin-top: 10px;
        height: 110px;
        .img{
            position: absolute;
            left: 15px;
            top: 0;
        }
        h3{
            padding-top: 5px;
        }
        .money{
            color: rgba(255, 148, 94, 1);
        }
        .num{
            color: rgba(84, 169, 119, 1);
        }
    }
    .commodityClolr{
        padding: 20px 0;
        h3{
            padding: 5px 0 5px 0;
        }
        .tag{
            display: inline-block;
            padding: 4px 8px;
            border: 1px solid #e8eaec;
            color: #515a6e;
            border-radius: 3px;

            cursor: pointer;
            margin: 5px 5px 0 0;
        }
    }
    .commoditymiss{
        h3{
            margin: 20px 0 10px;
        }
        table{
            width: 100%;
            text-align: center;
            tr{
                td{
                    padding-top: 10px;
                }

            }
        }
    }
    .Total{
        width: 100%;
        position: absolute;
        right: 0;
        bottom: 0;
        text-align: center;
        padding: 15px;
        background: #dcdee2;
        color:#ff9900
    }
    .formSelect-input{
        width: 180px;
    }

    .isSelectClass{
        background: #ff9800;
        color: #ffffff!important;
    }
    .msg{
        display: inline-block;
        margin-bottom: 20px;
        strong{
            color: #ff7f7f;
        }

    }

</style>